import React, {useState, useRef} from 'react';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';
import axios from 'axios';
import endpoints, { getBackendUrl } from '../../../endpoints';
import { useSelector, useDispatch } from 'react-redux'
import CloseIcon from '@mui/icons-material/CloseRounded';

let data = null;

export default function EditUserModal(props) {        
    if (props.dialogData) {
        data = props.dialogData;
    }
    
    const [errors, setErrors] = useState(null)
    if (data == null && errors !== null) {
        setErrors(null)
    }
    
    const token = useSelector((state) => state.auth.token)
    
    const firstnameRef = useRef()
    const lastnameRef = useRef()
    const roleRef = useRef()
    const statusRef = useRef()
    
    const save = async () => {
        if (props.dialogData == null) return
        
        const params = {
            firstname: firstnameRef.current.value,
            lastname: lastnameRef.current.value,
            role: roleRef.current.value,
            status: statusRef.current.value,
        }
        
        let res = null
        try {
            let uri = getBackendUrl(endpoints.users_edit, token).replace('{id}', props.dialogData.id)
            res = await axios.put(uri, params)            
            props.onSave()
        } catch (err) {
            if (err.response.data.status == 'invalidate') {
                const e = err.response.data.details
                setErrors(e)
            }
        }
    }

    return (
        <Dialog open={props.dialogData ? true : false} fullWidth maxWidth="xs" onClose={props.onClose}>
            <form onSubmit={(e) => {e.preventDefault()}}>
                <DialogTitle>
                    User Properties
                    <IconButton
                        onClick={props.onClose}
                        sx={{
                          position: 'absolute',
                          right: 8,
                          top: 8,
                          color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Stack direction="row" spacing={5}>
                        <Avatar src={data?.avatar_url} sx={{width: 96, height: 96}} />
                        <Stack spacing={2} sx={{flexGrow: 1}}>
                            <TextField
                                fullWidth 
                                name="firstname" 
                                label="First Name" 
                                variant="filled" 
                                helperText={errors?.firstname}
                                error={errors?.firstname}
                                defaultValue={data?.firstname}
                                inputRef={firstnameRef}
                            />
                            <TextField
                                fullWidth 
                                name="lastname" 
                                label="Last Name" 
                                variant="filled" 
                                helperText={errors?.lastname}
                                error={errors?.lastname}
                                defaultValue={data?.lastname}
                                inputRef={lastnameRef}
                            />
                            <FormControl variant="filled" fullWidth>
                                <InputLabel id="roleLabel">Role</InputLabel>
                                <Select
                                    fullWidth
                                    labelId="roleLabel"
                                    name="role"
                                    error={errors?.role}
                                    defaultValue={data?.role || ''}
                                    inputRef={roleRef}
                                >
                                {props.roles.map((row, key) => (
                                    <MenuItem key={key} value={row.id}>{row.title}</MenuItem>
                                ))}
                                </Select>
                                <FormHelperText>{errors?.role}</FormHelperText>
                            </FormControl>
                            <FormControl 
                                variant="filled" 
                                fullWidth
                                error={errors?.status}
                            >
                                <InputLabel id="statusLabel">Status</InputLabel>
                                <Select
                                    name="status"
                                    fullWidth
                                    labelId="statusLabel"
                                    error={errors?.status}
                                    defaultValue={data?.status || ''}
                                    inputRef={statusRef}
                                >
                                    <MenuItem value='active'>Active</MenuItem>
                                    <MenuItem value='inactive'>Inactive</MenuItem>
                                </Select>
                                <FormHelperText>{errors?.status}</FormHelperText>
                            </FormControl>
                        </Stack>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onClose}>Cancel</Button>
                    <Button type="submit" onClick={save}>Save</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}